import { render, staticRenderFns } from "./UploadsPhotos.vue?vue&type=template&id=db117a46&scoped=true"
import script from "./UploadsPhotos.vue?vue&type=script&lang=js"
export * from "./UploadsPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadsPhotos.vue?vue&type=style&index=0&id=db117a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db117a46",
  null
  
)

export default component.exports